'use client';
import {logger} from 'lib/logger.js';
import sendCookieData from './sendCookieData.js';
import * as CookieConsent from 'vanilla-cookieconsent';
import {translations} from "./ConsetCookieLanguage.js";
import {
  CAT_NECESSARY, CAT_ANALYTICS,
  SERVICE_ANALYTICS_STORAGE
} from './ConsentCookieDefinitions.js'
import {
  hiddeConfigButton, showConfigButton,
  updateGtagConsent,
  setCookieData, eraseCookies
} from './helperConsent.js';

const processSaveData = () => {
    const data = CookieConsent.getCookie('data');
    sendCookieData(data).then(r => {
      if (r.status === 'success') {
        window.location.reload();
      } else {
        console.error('Problemas al enviar las cookies', r.content);
      }
    });

};

const getConsentConfig = (lang) => {

  return {
    // root: 'body',
    autoShow: true,
    // disablePageInteraction: true,
    hideFromBots: true,
    // mode: 'opt-in',
    revision: 0,
    page_scripts: true,

    cookie: {
       name: 'cc_cookie',
       domain: location.hostname,
       path: '/',
       sameSite: "Lax",
       expiresAfterDays: 365,
    },

    /**
     * Callback functions
     */
    onFirstConsent: ({cookie}) => {
      logger.log('onFirstConsent fired', cookie);
      updateGtagConsent('onFirstConsent');
      setCookieData();
      // Enviar Datos de Primer Consentimiento al WP
        processSaveData();
    },
    onConsent: ({cookie}) => {
      logger.log('onConsent fired!', cookie);
      updateGtagConsent('onConsent');
    },
    onChange: ({changedCategories, changedServices}) => {
      updateGtagConsent('onChange');
      //SET cookie  and Send to WP
      setCookieData();
      if(!CookieConsent.acceptedCategory(CAT_ANALYTICS)){
        eraseCookies([/^_ga/, '_gid']);
      }
      //SEND DATA TO WP
      processSaveData();
    },
    onModalReady: ({modalName}) => {
    },
    onModalShow: ({modalName}) => {
      hiddeConfigButton();
    },
    onModalHide: ({modalName}) => {
      showConfigButton();
    },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
      consentModal: {
        layout: 'bar wide',
        position: 'bottom right',
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box',
        equalWeightButtons: true,
        flipButtons: false,
      },
    },

    categories: {
      [CAT_NECESSARY]: {
        enabled: true, // this category is enabled by default
        readOnly: true, // this category cannot be disabled
      },
      [CAT_ANALYTICS]: {
        autoClear: {
          cookies: [
            {
              name: /^_ga/,
            },
            {
              name: '_gid',
            },
          ],
        },
        // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
        services: {
          [SERVICE_ANALYTICS_STORAGE]: {
            label: 'Google Analytics',
            onAccept: () => {
              updateGtagConsent('ga:onAccept');
            },
            onReject: () => {
              updateGtagConsent('ga:onReject');
            },
          }
        },
      },
    },

    language: {
      default: lang, //Default 'es'
      translations: {
       ...translations
      },
    },
  };
};

export default getConsentConfig;
